import React, {useEffect, useRef, useState} from 'react'
import {Button, Checkbox, Col, Form, Input, message, Modal, Row, Space, Table, List} from "antd";
import {EditOutlined, CheckOutlined} from '@ant-design/icons';
import {
  API_HOST_WEBSOCKET
} from "../../../../constants";
import {closeWebSocket, createWebSocket} from "../../../../utils/websocketUtil";
import {
  getTemplateListShop,
  getCategorieList,
  getActivityBarcodeProductList,
  getActivityMainProductList, getActivityMainProductSave
} from "../../../../constants/api";
import {removeToken} from "../../../../utils/cookie";

const FormItem = Form.Item

// const dedupe = require('dedupe')

export default (props) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [selectedRows, setSelectedRows] = useState([])
  const [categoryProduct, setCategoryProduct] = useState([])
  const [showSelectShopsModal, setShowSelectShopsModal] = useState(false)
  const [current, setCurrent] = useState(1)
  const [total, setTotal] = useState(0)
  const [pageSize, setPageSize] = useState(10)
  const [showSelectGoodsModal, setShowSelectGoodsModal] = useState(false)
  const [selectedRowKeysSync, setSelectedRowKeysSync] = useState([])
  const [shop, setShop] = useState([])
  const [inputProductName, setInputProductName] = useState('')
  const [inputProductCode, setInputProductCode] = useState('')
  const [editProductModal, setEditProductModal] = useState(false)
  const [activityPrice, setActivityPrice] = useState(null)
  const [activityAllStore, setActivityAllStore] = useState(null)
  const [activityEveryStore, setActivityEveryStore] = useState(null)
  const [goodsName, setGoodsName] = useState(null)
  const [goodsPrice, setGoodsPrice] = useState(null)
  const [selectGoods, setSelectGoods] = useState(false)
  const [confirmSelectGoods, setConfirmSelectGoods] = useState([])
  const [key, setKey] = useState(null)
  const [loadingAdd, setLoadingAdd] = useState(false)

  const [category, setCategory] = useState([])
  const [tempCategoryId, setTempCategoryId] = useState(0)

  const [selectedMore, setSelectedMore] = useState([])
  const [selectedProduct, setSelectedProduct] = useState([])

  const [activityT, setActivityT] = useState(2)
  const [storagePrice, setStoragePrice] = useState('')

  const [barCodes, setBarCodes] = useState([])

  const [batchPriceVisible, setBatchPriceVisible] = useState(false)
  const [inputPriceBatch, setInputPriceBatch] = useState('')
  const [batchDiscountVisible, setBatchDiscountVisible] = useState(false)
  const [inputDiscountBatch, setInputDiscountBatch] = useState('')

  const [modifyPriceVisible, setModifyPriceVisible] = useState(false)
  const [tempProductS, setTempProductS] = useState({})
  const [tempProductSPrice, setTempProductSPrice] = useState('')

  const formRef = useRef()

  useEffect(() => {
    if (key) {
      let url = "wss://" + API_HOST_WEBSOCKET + "/websocket/message/" + key;//服务端连接的url
      createWebSocket(url, setLoadingAdd, props.go)
      //在组件卸载的时候，关闭连接
      return () => {
        closeWebSocket();
      }
    }
    getShop()
    if (selectedRowKeysSync.length != 0) {
      getProductCategory()
    }
  }, [selectedRowKeysSync, key])

  // const removesDuplicates=(array,duplicatesValue)=> {
  //   return dedupe(array, duplicatesValue => duplicatesValue.productId)
  // };

  /**
   * 获取商品分类
   */
  const getProductCategory = () => {
    getCategorieList({
      pageIndex: 1,
      pageSize: 100,
      sortName: "",
      sortType: "descending",
      shopId: 0,
      templateId: props.templateId
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          setCategory(data.data.records)
          setTempCategoryId(data.data.records[0].categorieId)
          getProduct(data.data.records[0].categorieId)
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })

    // axios.post(API_GOODS_CLASSIFY, {
    //   pageIndex: 1,
    //   pageSize: 100,
    //   sortName: "",
    //   sortType: "descending",
    //   shopId: 0,
    //   templateId: props.templateId
    // })
    //     .then(function (response) {
    //       let data = response.data;
    //       console.log(data);
    //       if (data.code == 0) {
    //         setCategory(data.data.records)
    //         setTempCategoryId(data.data.records[0].categorieId)
    //         getProduct(data.data.records[0].categorieId)
    //       } else {
    //         message.error(data.msg, 1)
    //       }
    //     })
    //     .catch(function (error) {
    //       console.log(error);
    //     });
  }

  /**
   * @Description: 获取商品
   * @Author Jiang
   * @Date 2020/9/8 13:48
   */
  const getProduct = (id) => {
    getActivityMainProductList({
      categoryId: id,
      shopIds: selectedRowKeysSync,
      productName: inputProductName,
      barCode: inputProductCode,
      templateId: props.templateId
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          setCategoryProduct(data.data)
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg, 1)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })

    // axios.post(API_ADD_ACTIVITY_GOODS, {
    //   // pageIndex: current,
    //   // pageSize: pageSize,
    //   // sortName: "",
    //   // sortType: "descending",
    //   categoryId: id,
    //   shopIds: selectedRowKeysSync,
    //   productName: inputProductName,
    //   barCode: inputProductCode,
    //   templateId: props.templateId
    // })
    //   .then(function (response) {
    //     let data = response.data;
    //     console.log(data);
    //     if (data.code === 0) {
    //       // setTotal(data.data.total)
    //       setCategoryProduct(data.data)
    //     } else {
    //       message.error(data.msg, 1)
    //     }
    //   })
    //   .catch(function (error) {
    //     console.log(error);
    //   });
  }

  /**
   * @Description: 获取店铺数据
   * @Author Jiang
   * @Date 2020/9/8 15:55
   */
  const getShop = () => {
    getTemplateListShop({
      id: props.templateId,
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          setShop(data.data)
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })
    // axios.post(API_GOODS_SEARCH_SHOP, {
    //   id: props.templateId
    // })
    //   .then(function (response) {
    //     let data = response.data;
    //     console.log(data);
    //     if (data.code === 0) {
    //       setShop(data.data)
    //     } else {
    //       message.error(data.msg, 1)
    //     }
    //   })
    //   .catch(function (error) {
    //     console.log(error);
    //   });
  }

  const categoryItemAction = (categoryId) => {
    console.log(categoryId)
    setTempCategoryId(categoryId)
    getProduct(categoryId)
  }

  const searchProduct = () => {
    getProduct(tempCategoryId)
  }

  /**
   * @Description: table勾选触发事件
   * @Author Jiang
   * @Date 2020/9/8 13:43
   */
  const onSelectChange = (selectedRowKeystemp, selectedRowstemp) => {
    // console.log('selectedRowKeys changed: ', selectedRowKeys);
    // console.log(selectedRows)


    setSelectedRowKeys(selectedRowKeystemp)
    setSelectedRows(selectedRowstemp)

    let selectedMore = selectedProduct.concat(selectedRowstemp)
    // let selectedSet = unique(selectedProduct.concat(selectedRowstemp))
    console.log('---------------')
    console.log(selectedMore)
    setSelectedMore(selectedMore)
  };

  const unique = (arr) => {
    return Array.from(new Set(arr))
  }

  /**
   * @Description: table行选择对象
   * @Author Jiang
   * @Date 2020/9/8 13:43
   */
  const rowSelection = {
    onChange: onSelectChange,
  };

  /**
   * @Description: table行选择对象
   * @Author Jiang
   * @Date 2020/9/8 13:43
   */
  const rowSelection2 = {
    onChange: (selectedRowKeys, selectedRows) => {
      setConfirmSelectGoods(selectedRows)
    },
  };

  /**
   * @Description: 点击分页
   * @Author Jiang
   * @Date 2020/9/8 14:16
   */
  const onChangePage = (page, pageSize) => {
    setCurrent(page)

  }

  /**
   * @Description: 点击选择商品
   * @Author Jiang
   * @Date 2020/9/8 14:17
   */
  const showSelectGoods = () => {
    getProduct()
    setShowSelectGoodsModal(true)
  }

  /**
   * @Description: 选择商品确定事件
   * @Author Jiang
   * @Date 2020/9/8 14:24
   */
  const onHandleOk = () => {

  }

  /**
   * @Description: 选择商品取消
   * @Author Jiang
   * @Date 2020/9/8 14:24
   */
  const onHandleCancel = () => {
    setShowSelectGoodsModal(false)
  }

  /**
   * @Description: 打开店铺选择
   * @Author Jiang
   * @Date 2020/9/8 15:35
   */
  const showSelectShops = () => {
    setShowSelectShopsModal(true)
  }

  /**
   * @Description: 确认选择店铺
   * @Author Jiang
   * @Date 2020/9/8 15:45
   */
  const onHandleShopOk = () => {
    setShowSelectShopsModal(false)
    // getProductCategory()
  }

  /**
   * @Description: 取消选择店铺
   * @Author Jiang
   * @Date 2020/9/8 15:46
   */
  const onHandleShopCancel = () => {
    setShowSelectShopsModal(false)
  }


  /**
   * @Description: 选择店铺的选择按钮
   * @Author Jiang
   * @Date 2020/9/8 15:50
   */
  const rowSelectionSync = {
    selectedRowKeysSync,
    onChange: (selectedRowKeysSync) => {
      console.log(selectedRowKeysSync)
      setSelectedRowKeysSync(selectedRowKeysSync)
    },
  };

  /**
   * @Description: 选择店铺的勾选
   * @Author Jiang
   * @Date 2020/9/8 16:19
   */
  const onSelectChangeSync = selectedRowKeysSync => {
    console.log('selectedRowKeysSync changed: ', selectedRowKeysSync);
    setSelectedRowKeysSync(selectedRowKeysSync)
  };


  /**
   * @Description: 搜索商品名的输入
   * @Author Jiang
   * @Date 2020/9/8 18:17
   */
  const changeInputName = (e) => {
    setInputProductName(e.target.value)
  }
  /**
   * @Description: 搜索条形码的输入
   * @Author Jiang
   * @Date 2020/9/8 18:17
   */
  const changeInputCode = (e) => {
    setInputProductCode(e.target.value)
  }

  /**
   * @Description: 确定提交的商品
   * @Author Jiang
   * @Date 2020/9/8 21:09
   */
  const onSubmit = () => {
    //获取本地保存的活动类型和活动价
    let storage = window.localStorage;
    let type = storage.getItem('ACTIVITY_TYPE')
    let price = storage.getItem('ACTIVITY_P')
    setActivityT(type)
    setStoragePrice(price)
    console.log('***')
    console.log(type)
    console.log(price)

    setSelectGoods(true)
    // let selectedSet = unique(selectedMore)
    // console.log('***')
    // console.log(type)
    // console.log(selectedSet)
    // setSelectedProduct(selectedSet)

    let selectedSet = []
    let obj = {}
    for (let i = 0; i < selectedMore.length; i++) {
      if (!obj[selectedMore[i].productId]) { // name  对应数组中的name
        selectedSet.push(selectedMore[i])
        obj[selectedMore[i].productId] = true
      }
    }

    // let selectedSet = removesDuplicates(selectedMore,selectedMore.productId);
    setSelectedProduct(selectedSet)
  }

  /**
   * @Description: 确定提交商品
   * @Author Jiang
   * @Date 2020/9/8 21:16
   */
  const onAddGoods = () => {
    let tempProducts = []
    if (confirmSelectGoods.length !== 0) {
      setLoadingAdd(true)
      if (activityT == 2) {
        confirmSelectGoods.map((item, index) => {
          let obj = {
            dayStock: (item.dayStock == '' || !item.dayStock)? '999': item.dayStock,
            giftProductId: "",
            productId: item.productId,
            specialPrice: item.video,
            stock: (item.stock == '' || !item.stock)? '999': item.stock
          }
          tempProducts.push(obj)
        })
      } else {
        confirmSelectGoods.map((item, index) => {
          let obj = {
            dayStock: (item.dayStock == '' || !item.dayStock)? '999': item.dayStock,
            giftProductId: "",
            productId: item.productId,
            specialPrice: storagePrice,
            stock:(item.stock == '' || !item.stock)? '999': item.stock
          }
          tempProducts.push(obj)
        })
      }
    } else {
      message.error("请选择商品", 1)
      return false
    }

    getActivityMainProductSave({
      activityId: props.activityId,
      platformType: 5,
      products: tempProducts,
      shopIds: selectedRowKeysSync,
      templateId: props.templateId
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          if (data.data.dataHandleStatus === 0) {
            //建立websocket
            setKey(data.data.messageKey)
          } else {
            setTimeout(() => {
              setSelectGoods(false)
            }, 1000);
          }
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          setLoadingAdd(false)
          message.error(data.msg, 1)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })

    // axios.post(API_ADD_ACTIVITY, {
    //   activityId: props.activityId,
    //   platformType: 5,
    //   products: tempProducts,
    //   shopIds: selectedRowKeysSync,
    //   templateId: props.templateId
    // })
    //   .then(function (response) {
    //     let data = response.data;
    //     console.log(data);
    //     if (data.code === 0) {
    //       if (data.data.dataHandleStatus === 0) {
    //         //建立websocket
    //         setKey(data.data.messageKey)
    //       } else {
    //         setTimeout(() => {
    //           setSelectGoods(false)
    //         }, 1000);
    //       }
    //     } else {
    //       setLoadingAdd(false)
    //       message.error(data.msg, 1)
    //     }
    //   })
    //   .catch(function (error) {
    //     console.log(error);
    //   });
  }

  /**
   * @Description: 取消确定商品
   * @Author Jiang
   * @Date 2020/9/9 8:27
   */
  const onCancelGoods = () => {
    setSelectGoods(false)
  }
  const onOkGoods = () => {
    setSelectGoods(false)
  }
  const onSaveGoods = () => {
    setSelectGoods(false)
  }

  /**
   * @Description: 改变页数
   * @Author Jiang
   * @Date 2020/9/9 15:44
   */
  const onChangeSize = (current, size) => {
    console.log(size)
    setPageSize(size)
  }

  const onShowModal = (record) => {
    console.log(record.video)

    setActivityPrice(record.video)
    setActivityAllStore(record.shopCount)
    setActivityEveryStore(record.sortNum)
    setGoodsName(record.productName)
    setGoodsPrice(record.price)
    setEditProductModal(true)

  }

  const onChangeEdit = (type, record, e) => {
    // selectedRows.map((item, index) => {
    //   if (item.productId === record.productId) {
    //     switch (type) {
    //       case "price":
    //         item.video = e.target.value
    //         break;
    //       case "allStore":
    //         item.shopCount = e.target.value
    //         break;
    //       case "store":
    //         item.sortNum = e.target.value
    //         break;
    //       default:
    //     }
    //   }
    // })

    selectedProduct.map((item, index) => {
      if (item.productId === record.productId) {
        switch (type) {
          case "price":
            item.video = e.target.value
            break;
          case "allStore":
            item.stock = e.target.value
            break;
          case "store":
            item.dayStock = e.target.value
            break;
          default:
        }
      }
    })

  }

  const onHandleEditOk = () => {
    const values = formRef.current.getFieldValue()
    console.log(values)
    if (values.allStore) {
      setActivityAllStore(values.allStore)
    } else {
      message.error("请正确填写活动总库存", 1)
    }
    if (values.everyStore) {
      setActivityEveryStore(values.everyStore)
    } else {
      message.error("请正确填写每日活动库存", 1)
    }
    if (values.specialPrice) {
      setActivityPrice(values.specialPrice)
    } else {
      message.error("请正确填写活动价", 1)
    }
  }
  const onHandleEditCancel = () => {
    setEditProductModal(false)
  }

  const changeInputBarcodes = e => {
    console.log(e.target.value.trim())
    let codeArry = e.target.value.trim().split('\n')
    console.log(codeArry)
    setBarCodes(codeArry)
  }

  /**
   * 批量导入商品
   */
  const batchGoods = () => {
    getActivityBarcodeProductList({
      shopIds: selectedRowKeysSync,
      barCodes: barCodes,
      templateId: props.templateId
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          //获取本地保存的活动类型和活动价
          let storage = window.localStorage;
          let type = storage.getItem('ACTIVITY_TYPE')
          let price = storage.getItem('ACTIVITY_P')
          setActivityT(type)
          setStoragePrice(price)

          let selectedMore = selectedProduct.concat(data.data)
          console.log("______________")
          console.log(selectedMore)

          // let selectedSet = unique(selectedMore)
          // console.log("++++++++++++++")
          // console.log(selectedSet)
          // setSelectedProduct(selectedSet)

          let selectedSet = []
          let obj = {}
          for (let i = 0; i < selectedMore.length; i++) {
            if (!obj[selectedMore[i].productId]) { // name  对应数组中的name
              selectedSet.push(selectedMore[i])
              obj[selectedMore[i].productId] = true
            }
          }
          // let selectedSet = removesDuplicates(selectedMore,selectedMore.productId);
          console.log("++++++++++++++")
          console.log(selectedSet)
          setSelectedProduct(selectedSet)

          setSelectGoods(true)
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg, 1)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })



    // axios.post(API_ACTIVITY_IMPORT_BARCODE, {
    //   shopIds: selectedRowKeysSync,
    //   barCodes: barCodes,
    //   templateId: props.templateId
    // })
    //     .then(function (response) {
    //       let data = response.data;
    //       console.log('批量商品数据')
    //       console.log(data);
    //       if (data.code == 0) {
    //         //获取本地保存的活动类型和活动价
    //         let storage = window.localStorage;
    //         let type = storage.getItem('ACTIVITY_TYPE')
    //         let price = storage.getItem('ACTIVITY_P')
    //         setActivityT(type)
    //         setStoragePrice(price)
    //
    //         let selectedMore = selectedProduct.concat(data.data)
    //         console.log("______________")
    //         console.log(selectedMore)
    //
    //         // let selectedSet = unique(selectedMore)
    //         // console.log("++++++++++++++")
    //         // console.log(selectedSet)
    //         // setSelectedProduct(selectedSet)
    //
    //         let selectedSet = []
    //         let obj = {}
    //         for (let i = 0; i < selectedMore.length; i++) {
    //           if (!obj[selectedMore[i].productId]) { // name  对应数组中的name
    //             selectedSet.push(selectedMore[i])
    //             obj[selectedMore[i].productId] = true
    //           }
    //         }
    //         // let selectedSet = removesDuplicates(selectedMore,selectedMore.productId);
    //         console.log("++++++++++++++")
    //         console.log(selectedSet)
    //         setSelectedProduct(selectedSet)
    //
    //         setSelectGoods(true)
    //       } else {
    //         message.error(data.msg, 1)
    //       }
    //     })
    //     .catch(function (error) {
    //       console.log(error);
    //     });
  }

  const batchUpdatePrice = () => {
    setBatchPriceVisible(true)
  }
  const changeInputPriceBatch = e => {
    setInputPriceBatch(e.target.value)
  }
  const onBatchOk = () => {
    setBatchPriceVisible(false)

    let price = parseInt(inputPriceBatch)
    console.log(price)
    if (price > 0) {
      console.log('+++')
      selectedProduct.map((item, index) => {
        if (!item.video || item.video == null || item.video == '') {
          let p = parseFloat(item.price)
          let p2 = p + price
          console.log(p2)
          item.video = p2 + ''
        } else {
          let p = parseFloat(item.video)
          let p2 = p + price
          console.log(p2)
          item.video = p2 + ''
        }
      })
      setSelectedProduct(selectedProduct)
    } else {
      console.log('---')
      selectedProduct.map((item, index) => {
        if (!item.video || item.video == null || item.video == '') {
          let p = parseFloat(item.price)
          let p2 = p + price
          console.log(p2)
          if (p2 < 0) {
            item.video = '0'
          } else {
            item.video = p2 + ''
          }

        } else {
          let p = parseFloat(item.video)
          let p2 = p + price
          console.log(p2)
          if (p2 < 0) {
            item.video = '0'
          } else {
            item.video = p2 + ''
          }
        }

      })
      setSelectedProduct(selectedProduct)
    }

  }
  const onBatchCancel = () => {
    setBatchPriceVisible(false)
  }

  const batchUpdatePrice2 = () => {
    setBatchDiscountVisible(true)
  }
  const changeInputDiscountBatch = e => {
    setInputDiscountBatch(e.target.value)
  }
  const onBatch2Ok = () => {
    setBatchDiscountVisible(false)

    let price = parseFloat(inputDiscountBatch)
    console.log(price)
    if (price > 0) {
      console.log('打折')
      selectedProduct.map((item, index) => {
        let p = parseFloat(item.price)
        let p2 = p * price
        console.log(p2)
        item.video = p2.toFixed(2) + ''
      })
      setSelectedProduct(selectedProduct)
    }

  }
  const onBatch2Cancel = () => {
    setBatchDiscountVisible(false)
  }

  const showEditPriceModal = (record) => {
    setTempProductS(record)
    setModifyPriceVisible(true)
  }
  const changeInputPrice = e => {
    setTempProductSPrice(e.target.value)
  }
  const onModifyPriceOk = () => {
    selectedProduct.map((item, index) => {
      if (item.productId === tempProductS.productId) {
        item.video = tempProductSPrice
      }
    })
    setModifyPriceVisible(false)
  }
  const onModifyPriceCancel = () => {
    setModifyPriceVisible(false)
  }

  const deleteSelectedProduct = (record, index) => {
    // let p = selectedProduct
    // p.splice(index, 1)
    // console.log(p)

    let selectedProdudeNew = []
    selectedProduct.map((item, index) => {
      if (item.productId === record.productId) {
      } else {
        selectedProdudeNew.push(item)
      }
    })
    setSelectedProduct(selectedProdudeNew)
  }

  const columnsSyncShop = [
    {
      title: '店',
      dataIndex: 'branchShopName',
    },
  ];

  const columnsSelect = [
    {
      title: '条形码',
      dataIndex: 'barCode',
      width: 100,
    },
    {
      title: '商品名称',
      dataIndex: 'product',
      width: 400,
      render: (text, record) => (
        <div>
          {
            <div
              style={{height: 40, display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
              <img style={{width: 40, height: 40}} src={record.imageUrl}/>
              <div style={{
                // textAlign: "center",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                marginLeft: "5px",
                justifyContent: "flex-start"
              }}>
                {record.productName}
              </div>
            </div>
          }
        </div>
      ),
    },
    {
      title: '售价',
      dataIndex: 'price',
      // width: 100,
      render: (text, record) => (
        <div>
          {record.price}
        </div>
      ),
    },
    {
      title: '活动价',
      dataIndex: 'video',
      // width: 100,
      render: (text, record) => (
        <div>
          {
            (activityT == 2) ?
                <span onClick={showEditPriceModal.bind(this, record)}>{record.video}<EditOutlined /></span>
                :
                <span>{storagePrice}</span>
                // <Input value={record.video} onChange={(e) => onChangeEdit("price", record, e)}/>
                // :
                // <Input defaultValue={storagePrice} disabled onChange={(e) => onChangeEdit("price", record, e)}/>
          }
        </div>
      ),
    },
    {
      title: '活动总库存',
      dataIndex: '',
      // width: 150,
      render: (text, record) => (
        <div>
          <Input defaultValue={'999'} onChange={(e) => onChangeEdit("allStore", record, e)}/>
        </div>
      ),

    },
    {
      title: '每日活动库存',
      dataIndex: '',
      // width: 150,
      render: (text, record) => (
        <div>
          <Input defaultValue={'999'} onChange={(e) => onChangeEdit("store", record, e)}/>
        </div>
      ),
    },
    {
      title: '操作',
      dataIndex: 'option',
      render: (text, record, index) => (
        <Space size="middle">
          <a style={{color: "#eb2509"}}
             onClick={deleteSelectedProduct.bind(this, record, index)}>删除</a>
          {/*<a onClick={() => onShowModal(record)}>编辑</a>*/}
        </Space>
      ),
    },
  ]
  const columnsP = [
    {
      title: '条形码',
      dataIndex: 'barCode',
      width: 100,
    },
    {
      title: '商品名称',
      dataIndex: 'product',
      width: 400,
      render: (text, record) => (
        <div>
          {
            <div
              style={{height: 40, display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
              <img style={{width: 40, height: 40}} src={record.imageUrl}/>
              <div style={{
                textAlign: "center",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                marginLeft: "5px",
              }}>
                {record.productName}
              </div>
            </div>
          }
        </div>
      ),
    },
    /*{
      title: '售价',
      dataIndex: 'price',
      width: 100,
      render: (text, record) => (
        <div>
          {record.price}
        </div>
      ),
    },
    {
      title: '活动价',
      dataIndex: 'video',
      width: 100,
      render: (text, record) => (
        <div>
          {record.video}
        </div>
      ),
    },
    {
      title: '活动总库存',
      dataIndex: 'shopCount',
      width: 100,
      render: (text, record) => (
        <div>
          {record.shopCount}
        </div>
      ),

    },
    {
      title: '每日活动库存',
      dataIndex: 'sortNum',
      width: 100,
      render: (text, record) => (
        <div>
          {record.sortNum}
        </div>
      ),
    },*/
    /* {
       title: '操作',
       dataIndex: 'option',
       render: (text, record) => (
         <Space size="middle">
           <a onClick={() => onShowModal(record)}>编辑</a>
         </Space>
       ),
     },*/
  ];
  return (
    <div style={{padding: "20px"}}>
      {/*选择商品*/}
      <Row style={{marginBottom: '20px'}}>
        <Col>
          <Button type={'primary'} onClick={showSelectShops}>
            选择店铺
          </Button>
        </Col>

        {
          selectedRowKeysSync.length != 0 ?
              <Col>
                <Input.TextArea style={{width: '240px', marginLeft: '20px', marginRight: "5px"}} onChange={changeInputBarcodes} placeholder="请粘贴复制好的条形码"/>
                <Button type={'primary'} onClick={batchGoods}>
                  导入
                </Button>
              </Col>
              : null
        }
      </Row>
      <Row style={{marginBottom: '20px'}}>
        <Col>
          <Input style={{width: '150px', marginRight: "5px"}} value={inputProductName}
                 onChange={changeInputName} placeholder="请输入商品名称"/>
          <Input style={{width: '150px'}} value={inputProductCode} onChange={changeInputCode}
                 placeholder="请输入条形码"/>
          <Button style={{marginLeft: '5px',}} shape="round" type="primary"
                  onClick={searchProduct.bind(this)}
          >
            搜索
          </Button>
          <Button style={{marginLeft: '5px',}} shape="round" type="primary"
                  onClick={() => {
                    setInputProductCode(''),
                      setInputProductName('')
                  }}>
            重置
          </Button>
        </Col>
      </Row>
      <Row>
        <Col span={'24'}>
          <div style={{display: "flex", flexDirection: "row"}}>
            <div style={{width: "100%", height: "480px", border: "1px solid #e3e3e3"}}>
              <Row>
                <Col span="5">
                  <List
                    size="small"
                    split={false}
                    dataSource={category}
                    style={{padding: "15px", height: "460px", overflow: 'auto'}}
                    renderItem={item => <List.Item>
                      <div key={item.categorieId} style={{display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'space-between', alignItems: 'center'}}>
                        <div style={{width: 136, display: 'flex', flexDirection: 'row', justifyContent: 'flex-start'}}>
                          <span onClick={categoryItemAction.bind(this, item.categorieId)}>{item.categorieName}</span>
                        </div>
                        <div>
                          {
                            tempCategoryId === item.categorieId ?
                                <span style={{width: '10px'}}><CheckOutlined style={{ fontSize: '14px', color: '#0b68d4' }}/></span>
                                :
                                <span style={{width: '10px'}}/>
                          }
                        </div>
                        {/*<span style={{width: '136px', display: 'inline-block', whiteSpace: 'nowrap'}}*/}
                        {/*        onClick={categoryItemAction.bind(this, item.categorieId)}> {item.categorieName} </span>*/}
                        {/*{*/}
                        {/*  tempCategoryId === item.categorieId ?*/}
                        {/*    <span style={{width: '10px'}}><CheckOutlined style={{ fontSize: '14px', color: '#0b68d4' }}/></span>*/}
                        {/*    :*/}
                        {/*    <span style={{width: '10px'}}/>*/}
                        {/*}*/}
                      </div>
                    </List.Item>}
                  />
                </Col>
                <Col span="19">
                  <Table rowKey="productId"
                         rowSelection={{...rowSelection}}
                         columns={columnsP}
                         scroll={{y: '450px'}}
                         pagination={false}
                         dataSource={categoryProduct}/>
                </Col>
              </Row>

              {/*<ConfigProvider locale={zhCN}>*/}
                <div style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "baseline",
                  justifyContent: "flex-end",
                  padding: "0 80px 0 0"
                }}>
                  {/*<Pagination style={{marginTop: "20px"}} showQuickJumper={true} onShowSizeChange={onChangeSize}*/}
                  {/*            current={current} pageSize={pageSize} total={total}*/}
                  {/*            onChange={onChangePage}/>*/}
                  <Button type={'primary'} onClick={onSubmit}>
                    确认
                  </Button>
                </div>
              {/*</ConfigProvider>*/}

            </div>

            {/*<div style={{padding: "20px", width: "40%", border: "1px solid #e3e3e3"}}>
              <div style={{textAlign: "left"}}>
                已选商品
              </div>
              <div style={{overflowY: "auto", height: "450px"}}>
                {selectedRows.map((item, index) => {
                  return <div style={{color: "#31b3e3", textAlign: "left"}} key={item.xmProductId}>
                    {item.productName}
                  </div>
                })}
              </div>

            </div>*/}
          </div>

        </Col>
      </Row>

      <Modal
        title="选择店铺"
        visible={showSelectShopsModal}
        onOk={onHandleShopOk}
        onCancel={onHandleShopCancel}
        okText="确认"
        cancelText="取消"
      >
        <div>
          <div style={{width: '100%', height: '600px'}}>
            <Table rowKey="branchShopId"
                   rowSelection={rowSelectionSync}
                   columns={columnsSyncShop}
                   pagination={false}
                   scroll={{y: '550px'}}
                   dataSource={shop}/>
          </div>
        </div>
      </Modal>

      <Modal
        title="编辑商品"
        width={'40%'}
        visible={editProductModal}
        onOk={onHandleEditOk}
        onCancel={onHandleEditCancel}
        okText="确认"
        cancelText="取消"
      >
        <div style={{
          width: '100%',
          height: '600px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'flex-start'
        }}>
          <Form ref={formRef}>
            <span style={{color: '#868686'}}>基本信息</span>
            <FormItem name='activityName' label="商品名称：" style={{marginLeft: '60px'}}>
              <span style={{color: '#000000'}}>{goodsName}</span>
            </FormItem>
            <FormItem name='activityPrice' label="商品价格：" style={{marginLeft: '60px'}}>
              <span style={{color: '#000000'}}>{goodsPrice}</span>
            </FormItem>
            <Input value={activityPrice} onChange={(e) => setActivityPrice(e)} style={{marginLeft: "20px"}}
                   placeholder="请输入商品活动价"/>

            <span style={{color: '#868686'}}>活动设置</span>
            <FormItem label="活动库存：" style={{marginLeft: '60px'}}>
              <div style={{marginLeft: '10px', marginTop: '10px'}}>
                <Checkbox checked={true}>每日活动库存</Checkbox>
                <Input value={activityEveryStore}
                       style={{marginLeft: "20px", marginTop: '5px', marginBottom: '5px'}} placeholder="请输入每日活动库存"/>
                <Checkbox checked={true}>活动总库存</Checkbox>
                <Input value={activityAllStore} style={{marginLeft: "20px", marginTop: '5px'}}
                       placeholder="请输入活动总库存"/>
              </div>
            </FormItem>
          </Form>
        </div>
      </Modal>

      <Modal
        title={"确定商品(当前选中" + confirmSelectGoods.length + "个)"}
        visible={selectGoods}
        onOk={onOkGoods}
        width={'90%'}
        onCancel={onCancelGoods}
        confirmLoading={loadingAdd}
        okText="确认"
        cancelText="取消"
        footer={null}
      >
        <div>
          <div style={{width: '100%', height: '600px'}}>
            <Table rowKey="productId"
                   rowSelection={{...rowSelection2}}
                   columns={columnsSelect}
                   scroll={{y: '450px'}}
                   pagination={false}
                   dataSource={selectedProduct}/>
          </div>
          <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-end", padding: "0 20px 0 0"}}>
            {
              (activityT == 2) ?
                  <div style={{marginRight: 30}}>
                    <Button onClick={batchUpdatePrice2}>批量打折</Button>
                    <Button style={{marginLeft: 10}} onClick={batchUpdatePrice}>批量改价</Button>
                  </div>
                  : null
            }

            <Button onClick={onCancelGoods}>取消</Button>
            <Button style={{marginLeft: 10}} type='primary' onClick={onSaveGoods}>确定</Button>
            <Button style={{marginLeft: 10}} type='primary' loading={loadingAdd} onClick={onAddGoods}>确定并提交</Button>
          </div>
        </div>
      </Modal>

      <Modal
          title="批量改价"
          width={'32%'}
          visible={batchPriceVisible}
          onOk={onBatchOk}
          onCancel={onBatchCancel}
          okText="确认"
          cancelText="取消"
      >
        <div style={{display: 'flex', flexDirection: 'column'}}>
            <span style={{color: '#000000', fontWeight: 'bold'}}>改价：<Input style={{width: '150px', marginLeft: '10px'}} value={inputPriceBatch} onChange={changeInputPriceBatch}
                                                                             placeholder="请输入价格"/></span>
          <span style={{color: '#868686', marginLeft: '50px', marginTop: '5px'}}>注：加价为正数，减价为负数，例如：加价10元：<span style={{color: '#ff0000'}}>10</span>，减价10元：<span style={{color: '#ff0000'}}>-10</span></span>
        </div>
      </Modal>

      <Modal
          title="批量打折"
          width={'32%'}
          visible={batchDiscountVisible}
          onOk={onBatch2Ok}
          onCancel={onBatch2Cancel}
          okText="确认"
          cancelText="取消"
      >
        <div style={{display: 'flex', flexDirection: 'column'}}>
            <span style={{color: '#000000', fontWeight: 'bold'}}>改价：<Input style={{width: '150px', marginLeft: '10px'}} value={inputDiscountBatch} onChange={changeInputDiscountBatch}
                                                                           placeholder="请输入折扣"/></span>
          <span style={{color: '#868686', marginLeft: '50px', marginTop: '5px'}}>注：折扣输入规则，例如：6折：<span style={{color: '#ff0000'}}>0.6</span>，65折：<span style={{color: '#ff0000'}}>0.65</span></span>
        </div>
      </Modal>

      <Modal
          title="改价"
          width={'32%'}
          visible={modifyPriceVisible}
          onOk={onModifyPriceOk}
          onCancel={onModifyPriceCancel}
          okText="确认"
          cancelText="取消"
      >
        <div style={{display: 'flex', flexDirection: 'column'}}>
            <span style={{color: '#000000', fontWeight: 'bold'}}>改价：<Input style={{width: '150px', marginLeft: '10px'}} defaultValue={tempProductS.video} onChange={changeInputPrice}
                                                                           placeholder="请输入价格"/></span>
          {/*<span style={{color: '#868686', marginLeft: '50px', marginTop: '5px'}}>注：加价为正数，减价为负数，例如：加价10元：<span style={{color: '#ff0000'}}>10</span>，减价10元：<span style={{color: '#ff0000'}}>-10</span></span>*/}
        </div>
      </Modal>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/pages/activitys/add-activity/add-goods/index.js